import React, { Component } from 'react'
import PropTypes from 'prop-types'

import LocalTime from '@components/Details/LocalTime'
import { EditAvatar } from '@components/Avatar'
import Header from '@components/Details/Header'

class ProfileHeader extends Component {
  static propTypes = {
    profileStore: PropTypes.object
  }

  renderLocalTime = () => {
    const { profile } = this.props.profileStore
    const timezoneId = profile.address.timezoneId
    if (!timezoneId) return

    return <LocalTime timezoneId={timezoneId} />
  }

  render () {
    const { getProfile, profile } = this.props.profileStore
    const { employee } = profile

    return (
      <Header>
        <div className='profile__avatar-wrapper'>
          <EditAvatar user={profile} onSuccess={() => getProfile(profile.id)} />
        </div>

        <div className='info'>
          <div>
            <div className='name-status-wrapper'>
              <h1 className={'m-r-sm'}>
                {profile.title} {profile.fullName}
              </h1>
            </div>
            <span className='code-label'>{employee.atheneumOffice.name}</span>
          </div>
        </div>
        {this.renderLocalTime()}
      </Header>
    )
  }
}

export default ProfileHeader
